<div class="need-help-wrapper text-center">
  <h2>Have any query or Need help?</h2>
  <p>Receive a call from Ketto Advisor</p>
  <app-sac-button label="Yes, I want to receive a call" width="320px" height="44px" [openLead]="true"></app-sac-button>
</div>
